import ZehrTabs from '../components/dr-zehr-tabs.svelte'
// import lozad from 'lozad'

const { $ } = window

export default {
	init() {
		let $zehrTabs = $('#zehr_tabs')

		if ($zehrTabs.length) {
			new ZehrTabs({
				target: $zehrTabs[0],
				props: $zehrTabs.data(),
			})
		}
	},
	// finalize() {
	// 	let observer = lozad()
	// 	observer.observe()
	// },
}
